module.exports = __webpack_public_path__ + "static/GT-America-Compressed-Medium-f4235868376d8692b7374b1bc95a99c6.woff";